import {useCallback, useEffect, useState} from "react";
import {Nullable} from "../../models/Common";
import FleetExpensesStore from "../../stores/FleetExpensesStore";
import {OptionMap} from "../../helpers/optionMap";

type SpendingTypesResponse = {
  spendingTypes: Nullable<OptionMap<string>>;
  isLoading: boolean;
};

export function useFleetExpensesSpendingTypes(store: typeof FleetExpensesStore): SpendingTypesResponse {
  const [loading, setLoading] = useState<boolean>(false);
  const [spendingTypes, setSpendingTypes] = useState<Nullable<OptionMap<string>>>(null);

  const fetchTransports = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);
      const result: Nullable<OptionMap<string>> = await store.getSpendingTypes();
      setSpendingTypes(result);
    } catch {
      console.warn('Error when fetching transports');
      setSpendingTypes(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchTransports();
  }, [fetchTransports]);

  return {
    spendingTypes: spendingTypes,
    isLoading: loading,
  };
}